import React from 'react';

import Button from '../../UI/Button/Button';
import FlexModal from '../../UI/FlexModal/FlexModal';

import classes from './AlertDialog.module.css';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import InfoIcon from '../../../assets/icons/info-icon-blue.svg';

const alertDialog = (props) => {
    return (
        <FlexModal visible={props.show} forZenStatSection={props.forZenStatSection}>
            <div className={classes.AlertDialog}>
                <img
                    className={classes.CloseIcon}
                    src={closeIconBlack}
                    alt="Close Icon"
                    onClick={props.closeHandler ? props.closeHandler : props.buttonClicked}
                />
                <img src={InfoIcon} className={classes.InfoIcon} />

                <h4 className={classes.Message}>{props.message}</h4>

                <div className={classes.Button}>
                    <Button
                        styleclass={"NonMobileOnly"}
                        label={props.buttonLabel}
                        clicked={props.buttonClicked}
                        margin="0px"
                        padding="8px 48px"
                    />
                    <Button
                        styleclass={"MobileOnly"}
                        label={props.buttonLabel}
                        clicked={props.buttonClicked}
                        margin="0px"
                        padding="8px"
                        fontSize="0.625em"
                        width="11.2em"
                    />
                </div>
            </div>
        </FlexModal>
    );
}

export default alertDialog;